import { Button, Heading, Icon } from "@elaniintc/goes-design-system";

interface DetailEmptyStateProps {
  canUpdateTable: boolean;
  onAddColumn: () => void;
}

export const DetailEmptyState = ({
  canUpdateTable,
  onAddColumn,
}: DetailEmptyStateProps) => {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center">
      <div className="flex flex-col pb-6">
        <Heading variant="h4" className="text-heading-quiet text-center">
          Aún no tienes registros
        </Heading>
        <p className="text-body-quiet font-normal">
          Agrega las columnas necesarias para tu nueva tabla
        </p>
      </div>
      {canUpdateTable && (
        <Button type="button" size="default" onClick={onAddColumn}>
          Agregar columna
          <Icon type="far" name="plus" />
        </Button>
      )}
    </div>
  );
};

export default DetailEmptyState;
